module.exports = __webpack_public_path__ + "img/diamond_vip.a4304c58.png";